import { render, staticRenderFns } from "./FormConfirmation.vue?vue&type=template&id=66ca4722"
import script from "./FormConfirmation.vue?vue&type=script&lang=js"
export * from "./FormConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports